import Depot from '../../_shared/depot';
const TabContentWithoutRef = ({ tabKey, content, active, ...commonProps }) => {
    if (!active)
        return null;
    return Depot.createElement('div', {
        id: `tabpanel-${tabKey}`,
        role: 'tabpanel',
        tabIndex: -1,
        'aria-labelledby': `tab-${tabKey}`,
        ...commonProps,
    }, content);
};
const TabContent = Depot.withRef(TabContentWithoutRef);
TabContent.displayName = 'TabContent';
export default TabContent;
//# sourceMappingURL=index.js.map